module.exports = ".example-margin {\n  margin: 0 10px;\n}\n\na, a:link, a:visited {\n  color: #e85356;\n}"